const defaultCoordinates = [51.42047, 35.729054];

const damagedPlacesValues = {
  front: [
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
  ],
  back: [
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
    [false, false, false],
  ],
  top: [false, false, false],
  bottom: [false, false, false],
  right: [false, false, false, false, false, false],
  left: [false, false, false, false, false, false],
};
const tabletWidth = 992;
const maxVerificationLength = 5;
const imageSliderTime = 8000;
const carrouselSliderTime = 5000;
const base64Prefix = "data:image/jpeg;base64,";
const instagramURL = "https://www.instagram.com/ctelecom";
const linkdinURL = "https://ir.linkedin.com/company/ctelecom-ir";
module.exports = {
  defaultCoordinates,
  damagedPlacesValues,
  maxVerificationLength,
  tabletWidth,
  imageSliderTime,
  carrouselSliderTime,
  base64Prefix,
  instagramURL,
  linkdinURL,
};
